import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { HotelAmenity } from '@hotels/hotel-detail/entities/hotel-detail.response';

@Component({
  selector: 'app-amenities-detail',
  templateUrl: './amenities-detail.component.html',
  styleUrls: ['./amenities-detail.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AmenitiesDetailComponent {

  @Input() amenities: HotelAmenity[] = [];

  public readonly amenitiesBasePath: string = 'web/travel/amenities';

  constructor() { }

}
